(function () {
  'use strict';

  var SELECTOR = '[data-wishlist-btn]';
  var GRID_SELECTOR = '.collection__products';

  function getWishlistKey(empi, epi) {
    return String(empi) + ':' + String(epi);
  }

  function buildWishlistMap(items) {
    var map = {};

    items.forEach(function (item) {
      map[getWishlistKey(item.empi, item.epi)] = true;
    });

    return map;
  }

  function getProductPayload(button) {
    return {
      empi: Number(button.dataset.productId),
      epi: Number(button.dataset.variantId),
      du: button.dataset.productUrl,
    };
  }

  function updateButtonState(button, isWishlisted) {
    button.classList.toggle('swym-added', isWishlisted);
    button.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');

    if (button.dataset.addLabel) {
      button.setAttribute(
        'aria-label',
        isWishlisted ? button.dataset.removeLabel : button.dataset.addLabel
      );
    }
  }

  function syncButtonState(button, wishlistMap) {
    var payload = getProductPayload(button);
    var isWishlisted = !!wishlistMap[getWishlistKey(payload.empi, payload.epi)];
    updateButtonState(button, isWishlisted);
  }

  function bindButtons(swat, wishlistMap) {
    document.querySelectorAll(SELECTOR).forEach(function (button) {
      if (button.dataset.wishlistBound === 'true') {
        syncButtonState(button, wishlistMap);
        return;
      }

      button.dataset.wishlistBound = 'true';
      syncButtonState(button, wishlistMap);

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var payload = getProductPayload(button);
        var isWishlisted = button.classList.contains('swym-added');

        if (isWishlisted) {
          swat.removeFromWishList(payload, function () {
            updateButtonState(button, false);
          });
          return;
        }

        swat.addToWishList(payload, function () {
          updateButtonState(button, true);
        });
      });
    });
  }

  function initCollectionWishlist(swat) {
    swat.fetch(function (items) {
      bindButtons(swat, buildWishlistMap(items || []));
    });
  }

  function observeGrid(swat) {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid || grid.dataset.wishlistObserved === 'true') return;

    grid.dataset.wishlistObserved = 'true';

    var observer = new MutationObserver(function () {
      initCollectionWishlist(swat);
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function onSwymReady(swat) {
    initCollectionWishlist(swat);
    observeGrid(swat);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);
})();
